const moduleName = '.media'

export default ({
  repository,
  clientWrapper,
  context
}) => ({
  getUrlById: (mediaId, format = null) => {
    context.lastApiPath = 'no_notificate'
    return clientWrapper.api
      .get(`/media/${mediaId}`, { params: { format } })
      .then(res => repository.baseMediaDomain + res)
  },

  getUrlByPath: (mediaPath) => {
    context.lastApiPath = 'no_notificate'
    return clientWrapper.api.get(mediaPath).then(res => 
      res ? repository.baseMediaDomain + res : null
    )
  },

  share: (mediaIds, message, recipients) => {
    context.lastApiPath = 'common.shareImage'

    return clientWrapper.api.post('/media/share_via_email', {
      recipient_emails: recipients,
      media_ids: mediaIds,
      message
    })
  },

  delete: (id) => {
    context.lastApiPath = `${moduleName}.item`
    
    return clientWrapper.api.delete(`/media/${id}`)
  }
})
